module.exports = __webpack_public_path__ + "static/media/our-brand.ed89e035.jpg";